export default {
    auth: {
        login: {
            title: 'Đăng nhập Giáo viên',
            buttons: {
                enter: 'Đăng nhập',
                chathess: 'Đăng nhập Chathess',
                register: 'Đăng ký',
            },
        },
    },
    register: {
        title: 'Đăng ký',
        description: 'Vui lòng nhập thông tin cần thiết để đăng ký',
        chathessId: 'ID Chathess',
        accountInfo: 'Thông tin tài khoản',
        accessId: 'ID',
        password: 'Mật khẩu',
        passwordConfirm: 'Xác nhận mật khẩu',
        buttons: {
            cancel: 'Hủy',
            register: 'Đăng ký',
        },
    },
    home: {
        title: 'Bấm vào hoạt động để bắt đầu học.',
    },
    self: {
        title: 'Tình trạng chế độ tự học',
        clear: 'Tất cả đã hoàn thành!',
        tabs: {
            all: 'Xem tất cả',
            completed: 'Học sinh đã hoàn thành',
            inProgress: 'Học sinh đang học',
        },
        noStudent: ({ values }: { values: { tab: string } }) => {
            const { tab } = values;

            if (tab === 'completed') {
                return 'Không có học sinh đã hoàn thành.';
            } else if (tab === 'in_progress') {
                return 'Không có học sinh đang học.';
            } else {
                return 'Không có học sinh.';
            }
        },
        table: {
            name: 'Tên',
            progress: 'Tỷ lệ hoàn thành',
            module: 'Mô-đun',
            time: 'Thời gian đã dùng',
        },
    },
};
